let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("94zwy")).then(() => parcelRequire('dw46F'));